import React from 'react';
import { DoubleChainActionIcon } from 'components/ScenarioSetup/ActionIcons/DoubleChainActionIcon';
import { FacebookAdsIcon } from 'assets/icons/FacebookAdsIcon';
import { FacebookAdsIconAlt } from 'assets/icons/FacebookAdsIconAlt';

export const FacebookAds = ({ id, actionType, title, isShowWarningActionMessage, isOpenActionInfo }) => {

    const actionIconConditions = {
        base: {
            icon: FacebookAdsIcon,
            iconProps: {
                width: '48px',
                height: '48px',
                color: '#FFFFFF',
                bgColor: '#0CBFE7'
            }
        },
        opened: {
            icon: FacebookAdsIconAlt,
            iconProps: { borderColor: '#0CBFE7' }
        },
        warning: {
            icon: FacebookAdsIconAlt,
            iconProps: { borderColor: '#FC4A54' }
        }
    };

    return <DoubleChainActionIcon {...{
        id,
        actionType,
        title,
        isShowWarningActionMessage,
        isOpenActionInfo,
        actionIconConditions,
    }} />
};
